import React from 'react'
import { Images } from "../theme"
import { Link } from "gatsby"

const HomeTestimonial = () => {
    return (
        <div className="hmtstmnl">
            <div className="fx fxdc">
                <div className="pd25"> 
            <h2>Incredible Testimonial - Natural Silver Champion</h2>
                <div className="">
<p>
We have been following an incredible testimonial about Mukamana, a woman who had been suffering from chronic wounds for a long time. Mukamana struggle with these persistent wounds was both painful and frustrating, as other treatments seemed to have minimal effect on healing. However, her life took a turn for the better when she discovered the remarkable healing properties of colloidal silver solution.
</p><p>
Before stumbling upon this alternative treatment option, Mukamana had tried numerous creams, ointments, and medications all promising to heal her wounds. Unfortunately, none of them seemed to work effectively, leaving her in a state of despair and discomfort.
</p><p>
Feeling defeated, she began to explore natural remedies and stumbled upon colloidal silver solution. Intrigued by its purported healing abilities, she decided to give it a try, hoping for a miracle, and what she experienced exceeded all her expectations.
</p>
                <span className="mobtn">
                    <Link to="/testimonial">Read More</Link>
                </span>
                </div>

            </div>
            </div>
          </div>
    )
}

export default HomeTestimonial
